export default {"src":"/_next/static/media/not-section8.26aac306.svg","height":128,"width":263,"blurWidth":0,"blurHeight":0};